import types from '../types'
import Action from '../../types/Action'

const initialState = {
  addUser: {
    loading: false,
    success: false,
    error: false,
    data: []
  },
  userExists: {
    loading: false,
    success: false,
    error: false,
    data: []
  },
}

const applicationProcessReducer = (state = initialState, action: Action) => {
  switch (action.type) {
  	case types.ADD_APP_PROCESS_USER_REQUESTED: {
      return {
        ...state,
        addUser: {
          loading: true,
          error: false,
          success: false,
	    	  data: []
        }
      }
    }
    case types.ADD_APP_PROCESS_USER_FULFILLED: {
      return {
        ...state,
        addUser: {
	    	  ...state.addUser,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
  	case types.ADD_APP_PROCESS_USER_REJECTED: {
      return {
        ...state,
        addUser: {
    		  ...state.addUser,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.VALIDATE_USER_REQUESTED: {
      return {
        ...state,
        userExists: {
          loading: true,
          error: false,
          success: false,
		      data: []
        }
      }
    }
    case types.VALIDATE_USER_FULFILLED: {
      return {
        ...state,
        userExists: {
		      ...state.userExists,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
  	case types.VALIDATE_USER_REJECTED: {
      return {
        ...state,
        userExists: {
		      ...state.userExists,
          loading: false,
          error: action.payload
        }
      }
    }
    default: {
      return state
    }
  }
}

export default applicationProcessReducer